import { ReactNode } from "react"

interface SubmenuColumnProps {
    children: ReactNode
}

export function SubmenuColumn(props: SubmenuColumnProps) {
    return <div className="desktop-navigation-submenu-column">{props.children}</div>
}
